import _ from 'underscore';
import {isEmpty} from "../utils";

export type TOperator = "NE"|"LT"|"LE"|"EQ"|"GE"|"GT"|"ISEMPTY";

export class ComparisonOperator {
 	public static operator(operator: TOperator): (a: any, b: any) => boolean {

        /* tslint:disable:triple-equals */
        if(operator === "NE") {
            return (a, b) => a != b
        }
        if(operator === "LT") {
            return (a, b) => a < b
        }
        if(operator === "LE") {
            return (a, b) => a <= b
        }
        if(operator === "EQ") {
            return (a, b) => a == b
        }
        if(operator === "GE") {
            return (a, b) => a >= b
        }
        if(operator === "GT") {
            return (a, b) => a > b
        }
        if(operator === "ISEMPTY") {
            return a => isEmpty(a);
        }
        // default EQ
        return (a, b) => a == b;
        /* tslint:enable:triple-equals */
    }

    public static undefinedSafe(operator: TOperator) {
        if(operator === "ISEMPTY") {
            return ComparisonOperator.operator("ISEMPTY");
        }
        return (a: any, b: any): boolean|undefined => (_.isUndefined(a) || _.isUndefined(b)) ? undefined : ComparisonOperator.operator(operator)(a, b);
    }

    public static numericSafe(operator: TOperator) {
        if(operator === "ISEMPTY") {
            return ComparisonOperator.operator("ISEMPTY");
        }

        function toNumeric(v:string) {
            const int = parseInt(v, 10);
            return String(v) === String(int) ? int : v;
        }
        return (a: any, b: any): boolean|undefined => {
            return ComparisonOperator.undefinedSafe(operator)(toNumeric(a), toNumeric(b));
        }
    }

    public static describe(operator: TOperator): string {
 	    switch(operator) {
            case 'NE': return '!=';
            case 'LT': return '<';
            case 'LE': return '<=';
            case 'EQ': return '==';
            case 'GE': return '>=';
            case 'GT': return '>';
            case 'ISEMPTY': return 'ISEMPTY?'
            default: return '==';
        }
    }

}